import { render, staticRenderFns } from "./ProjectStretchGoalsList.vue?vue&type=template&id=fda33dfc&"
import script from "./ProjectStretchGoalsList.vue?vue&type=script&lang=js&"
export * from "./ProjectStretchGoalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports